import { Strings } from '@app/constants';
import { IBankInfoSchema } from '../types';
import { DetailsCard } from '@app/components/card';

interface Props {
  userData: IBankInfoSchema;
}
export const BankInfo = ({ userData }: Props) => {
  const bankDetails = userData?.bankInformation;
  const fields = [
    Strings.field.accountHolderName,
    Strings.field.fatherName,
    Strings.field.bankName,
    Strings.field.ifsc,
    Strings.field.accountType,
    Strings.field.accountNumber,
  ];
  const data = [
    bankDetails?.accountHolderName ? bankDetails.accountHolderName : 'NA',
    bankDetails?.fatherName ? bankDetails.fatherName : 'NA',
    bankDetails?.bankName ? bankDetails.bankName : 'NA',
    bankDetails?.ifscCode ? bankDetails.ifscCode : 'NA',
    bankDetails?.accountType ? bankDetails.accountType : 'NA',
    bankDetails?.accountNumber ? bankDetails.accountNumber : 'NA',
  ];

  return (
    <DetailsCard
      title={Strings.profile.bankInformation}
      fields={fields}
      data={data}
      height={'270px'}
      iconImg={'ic_bank'}
    />
  );
};
